<template>
    <textarea
        :value="value"
        cols="40" rows="10"
        :disabled="disable"
        @input="emitInput"
        autocomplete="no"
    />
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: '',
        },
        disable: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        emitInput: function(event) {
            this.$emit('input', event.target.value)
        }
    },
}
</script>

<style scoped>
textarea {
    display: block;
    width: 100%;
    resize: vertical;
}
</style>
